import { z } from 'zod';

import type { TFunction } from 'i18next';

import { KEY_TYPE_LIQPAY, KEY_TYPE_MONOPAY } from '@/constants';

export function createOnlinePaymentKeyFormSchema(
  t: TFunction,
  isEditMode = false,
) {
  return z
    .object({
      name: z
        .string({ message: t('validation_required') })
        .min(1, { message: t('validation_required') })
        .trim(),
      key_type: z
        .string({ message: t('validation_required') })
        .min(1, { message: t('validation_required') }),
      active: z.boolean(),
      public_key: z.string().optional(),
      private_key: z.string().optional(),
      x_token: z.string().optional(),
      cash_register_id: z.string().nullable(),
    })
    .superRefine((data, ctx) => {
      // In edit mode, keys are disabled and don't need validation
      if (isEditMode) return;

      if (data.key_type === KEY_TYPE_LIQPAY) {
        if (!data.public_key || data.public_key.trim().length === 0) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: t('validation_required'),
            path: ['public_key'],
          });
        }
        if (!data.private_key || data.private_key.trim().length === 0) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: t('validation_required'),
            path: ['private_key'],
          });
        }
      }

      if (data.key_type === KEY_TYPE_MONOPAY) {
        if (!data.x_token || data.x_token.trim().length === 0) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: t('validation_required'),
            path: ['x_token'],
          });
        }
      }
    });
}

export type OnlinePaymentKeyFormValues = z.infer<
  ReturnType<typeof createOnlinePaymentKeyFormSchema>
>;
